import { Pipe, PipeTransform } from '@angular/core';

import { ToPlural } from '../utils/to-plural';

@Pipe({
  standalone: true,
  name: 'plural'
})
export class PluralPipe implements PipeTransform {
  transform(word: string, array: any[], customPlural?: string): string {
    return ToPlural(word, array, customPlural);
  }
}
